import React, { useState ,useEffect} from "react";

// CSS
import "./../../../assets/css/purchase/datatable.css";

// Utils
import {
  formatCurrency,
  getData,
  getDataWithComp,
  parseCurrency,
} from "../../../utils/SamuiUtils";

import { formatDate, formatDateAndTime2 } from "../../../utils/DateUtils";
import FileModal from "../../components/Modal/FileModal";
import Pagination from "../Footer/Pagination";

const DataTable = ({
  currentItems,
  onRowSelected,
  currentPage,
  handlePageChange,
  dataMasterList,
  itemsPerPage,
  fieldMappings,
  getReport,
  setItemsPerPage,
  setCurrentPage,
  totalAmount,
}) => {
  // State สำหรับเก็บ ID แถวที่เลือก
  const [selectedRow, setSelectedRow] = useState(null);

  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [itemsPerPageDropdown, setItemsPerPageDropdown] = useState(
    localStorage.getItem("itemsPerPageDropdown") || itemsPerPage
  );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedRecFiles, setSelectedRecFiles] = useState([]);
  const handleShowModal = async (files, docNo) => {
    // สำหรับใบสำคัญจ่ายเท่านั้น หน้าอื่นไม่กระทบแน่นวลลลล
    if (window.location.pathname === "/payment-voucher" && docNo) {
      const getPayH = await getDataWithComp("PAY_H", `AND Pay_No = '${docNo}'`);
      if (getPayH && getPayH.length > 0) {
        const getPayD = await getData("PAY_D", `Pay_Id = ${getPayH[0].Pay_Id}`);
        if (getPayD && getPayD.length > 0) {
          let recFiles = new Set();
          for (const pay of getPayD) {
            let getRecFiles = await getDataWithComp(
              "Upload_File_List",
              `AND DocCode_ID = 3 AND Doc_ID = ${pay.Rec_Id}`
            );
            if (getRecFiles && getRecFiles.length > 0) {
              for (const file of getRecFiles) {
                recFiles.add(file.File_Name);
              }
            }
          }
          setSelectedRecFiles(Array.from(recFiles));
        }
      }
    }

    setSelectedFiles(files);
    setShowViewAttachModal(true);
  };

  // เอามาใช้สำหรับหน้าใบจ่าย ให้ดักว่าเป็นผู้ขาย หรือ ลูกค้า
  const getApOrArCode = (data) => {
    return data[fieldMappings.apCode] || data[fieldMappings.apName]
      ? { code: data[fieldMappings.apCode], name: data[fieldMappings.apName] }
      : { code: data["AR_Code"], name: data["AR_Name"] };
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {
      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${
            currentPage === 1 ? "active" : ""
          }`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      for (
        let i = Math.max(currentPage - range, 2);
        i <= Math.min(currentPage + range, totalPages - 1);
        i++
      ) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${
              currentPage === i ? "active" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => handlePageChange(i)}
            >
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">
              ...
            </a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${
            currentPage === totalPages ? "active" : ""
          }`}
        >
          <a
            href="#"
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </a>
        </li>
      );
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${
              currentPage === i ? "active" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => handlePageChange(i)}
            >
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = parseCurrency(event.target.value);
    setItemsPerPageDropdown(newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    handlePageChange(1);
  };

  const handleIndex = (data, rowId) => {
    const storedDocNo = localStorage.getItem("SO_SelectedItem");

    if (!storedDocNo) {
      setSelectedRow(rowId);
      localStorage.setItem("SO_SelectedItem", data.Doc_No); // บันทึกไว้
    } else if (storedDocNo === data.Doc_No) {
      setSelectedRow(rowId); // กรณีคลิกซ้ำรายการเดิม
    }
  };

  useEffect(() => {
  const savedDocNo = localStorage.getItem("SO_SelectedItem");
  if (savedDocNo && dataMasterList .length > 0) {
    const matchedItem = dataMasterList .find(
      (item) => item.Doc_No === savedDocNo
    );
    if (matchedItem) {
      const rowId = matchedItem.Doc_No || dataMasterList .indexOf(matchedItem) + 1;
      setSelectedRow(rowId);
    }
  }
}, [dataMasterList ]);

  return (
    <div
      className="card d-flex flex-column"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div
        className="table-responsive flex-grow-1"
        style={{ overflowY: "auto", maxHeight: "100%" }}
      >
        <table
          id="basic-datatables"
          className="table table-striped table-hover"
          style={{ margin: "0px" }}
        >
          <thead className="thead-dark">
            <tr>
              <th className="text-center" style={{ width: "2%" }}>
                เลขที่เอกสาร
              </th>
              {/* <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "7%" }}
              >
                เลขที่ใบวางบิล
              </th> */}
              <th
                hidden={
                  window.location.pathname === "/billofsale" &&
                  localStorage.getItem("company") === "2"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "9%" }}
              >
                เลขใบกำกับภาษี
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "2%" }}
              >
                เลขที่อ้างอิง
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ||
                  window.location.pathname === "/billofsale"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "6%" }}
              >
                ประเภท
              </th>
              <th
                hidden={
                  window.location.pathname === "/payment-voucher" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
              >
                ประเภทการจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "4%" }}
              >
                ประเภท
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "6%" }}
              >
                สถานะเอกสาร
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-request" ||
                  window.location.pathname === "/payment-voucher" ||
                  window.location.pathname === "/billofsale" ||
                  window.location.pathname === "/quotation"
                    ? true
                    : false
                }
                className="text-center"
                style={{ width: "12%" }}
              >
                สถานะเอกสาร
              </th>
              <th
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                สายส่ง
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "6%" }}
              >
                สถานะจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/product-receipt" ? false : true
                }
                className="text-center"
                style={{ width: "12%" }}
              >
                สถานะจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                ประเภทการจ่าย
              </th>
              <th
                hidden={
                  window.location.pathname === "/purchase-order" ? false : true
                }
                className="text-center"
                style={{ width: "10%" }}
              >
                สถานะรับสินค้า
              </th>
              <th className="text-center" style={{ width: "6%" }}>
                วันที่เอกสาร
              </th>
              <th
                className="text-center"
                hidden={
                  window.location.pathname === "/purchase-request" ||
                  window.location.pathname === "/picking-list"
                    ? true
                    : false
                }
                style={{ width: "6%" }}
              >
                {window.location.pathname === "/purchase-order"
                  ? "วันที่จัดส่ง"
                  : window.location.pathname === "/product-receipt"
                  ? "วันที่รับ"
                  : window.location.pathname === "/payment-voucher"
                  ? "วันที่ชำระ"
                  : "วันที่สร้าง"}
              </th>
              <th
                className="text-center"
                style={{ width: "5%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                window.location.pathname === "/deposit-document" ||
                window.location.pathname === "/billofsale"
                  ? "รหัสลูกค้า"
                  : "รหัสเจ้าหนี้"}
              </th>
              <th
                className="text-center"
                style={
                  window.location.pathname === "/purchase-order" ||
                  window.location.pathname !== "/product-receipt" ||
                  window.location.pathname !== "/payment-voucher"
                    ? { width: "20%" }
                    : { width: "40%" }
                }
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/quotation" ||
                window.location.pathname === "/deposit-document" ||
                window.location.pathname === "/billofsale"
                  ? " ชื่อลูกค้า"
                  : " ชื่อเจ้าหนี้"}
              </th>
              <th
                hidden={
                  window.location.pathname === "/deposit-document" ||
                  window.location.pathname === "/billofsale"
                    ? false
                    : true
                }
                className="text-center"
                style={{ width: "8%" }}
              >
                ชื่อผู้สร้างบิล
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 1
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 2
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                คนขับรถที่ 3
              </th>
              <th
                className="text-center"
                style={{ width: "8%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? false : true
                }
              >
                ทะเบียนรถ
              </th>
              <th
                className="text-center"
                style={{ width: "7%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                {window.location.pathname === "/payment-voucher"
                  ? "รวมจ่ายสุทธิ"
                  : "ยอดรวม"}
              </th>
              <th
                className="text-center"
                style={{ width: "10%" }}
                hidden={
                  window.location.pathname === "/purchase-request" ||
                  window.location.pathname === "/billofsale"
                    ? true
                    : false
                }
              >
                สร้างรายการ โดย
              </th>

              {window.location.pathname === "/purchase-request" && (
                <>
                  <th className="text-center" style={{ width: "10%" }}>
                    ผู้สั่งซื้อ
                  </th>
                  <th className="text-center" style={{ width: "6%" }}>
                    แผนกที่สั่งซื้อ
                  </th>
                </>
              )}

              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  window.location.pathname === "/purchase-request" ||
                  window.location.pathname === "/product-receipt" ||
                  window.location.pathname === "/payment-voucher"
                    ? false
                    : true
                }
              >
                ไฟล์
              </th>
              <th className="text-center" style={{ width: "1%" }}>
                แก้ไข
              </th>
              <th
                className="text-center"
                style={{ width: "1%" }}
                hidden={
                  window.location.pathname === "/picking-list" ? true : false
                }
              >
                พิมพ์
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((data, index) => {
                const { code, name } = getApOrArCode(data);
                const rowId = data[fieldMappings.no] || index + 1;

                return (
                  <tr
                    key={rowId}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        selectedRow === rowId
                          ? "rgb(105, 188, 216)"
                          : "transparent",
                      transition: "background-color 0.3s ease",
                    }}
                    onClick={() => handleIndex(data, rowId)}
                  >
                    <td className="text-center">
                      {data[fieldMappings.no] || "-"}
                    </td>
                    {/* <td
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docBlNo] || "-"}
                    </td> */}
                    <td
                      hidden={
                        window.location.pathname === "/billofsale" &&
                        localStorage.getItem("company") === "2"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.docInvNo] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.refDoc] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/payment-voucher" ||
                        window.location.pathname === "/picking-list" ||
                        window.location.pathname === "/billofsale"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.typeName] || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {/* {data[fieldMappings.docIsPickingList]} */}

                      <button
                        className="btn"
                        style={{
                          backgroundColor:
                            data[fieldMappings.docIsPickingList] === 0 ||
                            data[fieldMappings.docIsPickingList] === null
                              ? "#EAA300"
                              : "#13A10E",
                          color: "white",
                          width: "100%",
                        }}
                      >
                        {data[fieldMappings.docIsPickingList] === 0 ||
                        data[fieldMappings.docIsPickingList] === null
                          ? "S"
                          : "V"}
                      </button>
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale" ||
                        window.location.pathname === "/quotation"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/payment-voucher"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.payTypeName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data[fieldMappings.statusColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.payTypeName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-order"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusReceiveColor],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusReceiveName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/product-receipt"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusName] === "ยกเลิก" ? (
                        data[fieldMappings.statusName] ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: data[fieldMappings.statusColour],
                              color: "white",
                              width: "100%",
                            }}
                          >
                            {data[fieldMappings.statusName]}
                          </button>
                        ) : (
                          <center>
                            <p>-</p>
                          </center>
                        )
                      ) : data[fieldMappings.statusPaidName] ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidColour],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidName]}
                        </button>
                      ) : (
                        <center>
                          <p>-</p>
                        </center>
                      )}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.statusPaidTypeName] !== null ? (
                        <button
                          className="btn"
                          style={{
                            backgroundColor:
                              data[fieldMappings.statusPaidTypeColour],
                            color: "white",
                            width: "100%",
                          }}
                        >
                          {data[fieldMappings.statusPaidTypeName]}
                        </button>
                      ) : (
                        <>
                          {data[fieldMappings.statusName] === "ยกเลิก" ? (
                            data[fieldMappings.statusName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    data[fieldMappings.statusColour],
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.statusName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )
                          ) : data[fieldMappings.statusPaidName] ? (
                            <button
                              className="btn"
                              style={{
                                backgroundColor:
                                  data[fieldMappings.statusPaidColour],
                                color: "white",
                                width: "100%",
                              }}
                            >
                              {data[fieldMappings.statusPaidName]}
                            </button>
                          ) : (
                            <center>
                              <p>-</p>
                            </center>
                          )}
                        </>
                      )}
                    </td>
                    <td className="text-center">
                      {data[fieldMappings.date]
                        ? formatDate(data[fieldMappings.date])
                        : "-"}
                    </td>
                    <td
                      className="text-center"
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.dueDate]
                        ? formatDateAndTime2(data[fieldMappings.dueDate])
                        : "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      {code || "-"}
                    </td>
                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-left"
                    >
                      {name || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/deposit-document"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.dlLineName] || "-"}
                    </td>
                    <td
                      className="text-center"
                      hidden={
                        window.location.pathname === "/billofsale"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.createdBy] || "-"}
                    </td>
                    <td
                      className="text-end"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                    >
                      {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver1] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver2] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.driver3] || "-"}
                    </td>
                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? false
                          : true
                      }
                    >
                      {data[fieldMappings.carNo] || "-"}
                    </td>

                    <td
                      className="text-left"
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                        window.location.pathname === "/billofsale"
                          ? true
                          : false
                      }
                    >
                      {data[fieldMappings.createdBy] || "-"}
                    </td>

                    {window.location.pathname === "/purchase-request" && (
                      <>
                        <td className="text-left">
                          {data[fieldMappings.empName] || "-"}
                        </td>
                        <td className="text-left">
                          {data[fieldMappings.deptName] || "-"}
                        </td>
                      </>
                    )}

                    <td
                      hidden={
                        window.location.pathname === "/purchase-request" ||
                        window.location.pathname === "/product-receipt" ||
                        window.location.pathname === "/payment-voucher"
                          ? false
                          : true
                      }
                      className="text-center"
                    >
                      {data[fieldMappings.File_Name]?.length > 0 ? (
                        <button
                          className="btn btn-link btn-sm px-3"
                          onClick={() =>
                            handleShowModal(
                              data[fieldMappings.File_Name],
                              data[fieldMappings.no]
                            )
                          }
                        >
                          <i
                            className="fas fa-paperclip"
                            style={{
                              fontSize: "16px",
                              color: "rgb(239, 108, 0)",
                            }}
                          ></i>
                        </button>
                      ) : (
                        "-"
                      )}
                      {showViewAttachModal && (
                        <FileModal
                          mode={"S"}
                          showViewAttachModal={showViewAttachModal}
                          setShowViewAttachModal={setShowViewAttachModal}
                          selectedFiles={selectedFiles}
                          selectedRecFiles={selectedRecFiles}
                        />
                      )}
                    </td>

                    <td className="text-center">
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => onRowSelected(data[fieldMappings.no])}
                      >
                        <i
                          className="fa fa-edit"
                          style={{
                            color: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                        ></i>
                      </button>
                    </td>

                    <td
                      hidden={
                        window.location.pathname === "/picking-list"
                          ? true
                          : false
                      }
                      className="text-center"
                    >
                      <button
                        className="btn btn-link btn-sm px-3"
                        onClick={() => getReport(data[fieldMappings.no])}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={14}>
                  <center>
                    <h5>ไม่พบข้อมูล</h5>
                  </center>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div
        className="row mx-2"
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #ddd",
          paddingTop: "10px",
          paddingBottom: "10px",
          width: "100%",
        }}
      >
        <div className="col-12 d-flex justify-content-between">
          <div style={{ marginTop: "-32px" }}>
            <div className="fw-bold">
              จำนวนบิล: {dataMasterList.length.toLocaleString()} รายการ
            </div>
            <div className="d-flex align-items-center gap-2 mt-2">
              <label
                htmlFor="itemsPerPage"
                className="form-label mb-0 fw-bold"
                style={{ width: "111px" }}
              >
                แสดงแถวต่อหน้า:
              </label>
              <select
                value={itemsPerPageDropdown}
                onChange={handleItemsPerPageChange}
                className="form-select"
                style={{ width: "85px" }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
          <div style={{ width: "300px" }}>
            <div className="fw-bold mt-2">
              ยอดรวมทั้งหมด: {formatCurrency(totalAmount)} บาท
              <br />
              (ไม่รวมรายการที่ยกเลิก)
            </div>
            {/* <div
              className="dataTables_paginate paging_simple_numbers"
              id="basic-datatables_paginate"
            >
              <ul className="pagination">
                <li
                  className={`paginate_button page-item previous ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                >
                  <a
                    href="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </a>
                </li>
                {renderPageNumbers()}
                <li
                  className={`paginate_button page-item next ${
                    currentPage ===
                    Math.ceil(dataMasterList.length / itemsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <a
                    href="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </div> */}
            <div className="mt-2">
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPageDropdown}
                dataMasterList={dataMasterList}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
